import React, { useEffect, useMemo, useState } from 'react';

import css from '~/features/dashboard/components/quick-song-entry/styles.module.scss';
import {
    Box,
    Button,
    Divider,
    Drawer,
    Grid,
    Switch,
    Typography,
} from '@material-ui/core';
import classNames from 'classnames';
import { INewQuickSongFormInputs } from '~/models/music/new-song/formInputs';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { getUserProfile } from '~/features/dashboard/store/actions.thunks';
import { useRouteMatch } from 'react-router-dom';
import { push } from 'connected-react-router';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { DefaultsTab } from '~/features/dashboard/components/quick-song-entry/components/defaultsTab';
import { CreateQuickSongEntry } from '~/features/dashboard/components/quick-song-entry/components/create-quick-song';
import { UpdateQuickSongEntry } from '~/features/dashboard/components/quick-song-entry/components/update-quick-song';
interface MyQuickProps {}

export const QuickSongEntry: React.FC<MyQuickProps> = () => {
    const dispatch = useThunkDispatch();
    const match = useRouteMatch<{ creatorId: string }>();
    const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);
    const [toggle, setToggle] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [rows, setRows] = useState<INewQuickSongFormInputs[]>([]);

    useEffect(() => {
        dispatch(getUserProfile());
    }, [dispatch]);

    return (
        <article className={css.module}>
            <Grid container spacing={3}>
                <Grid item xs={2}>
                    <Button className={css.btnBack} onClick={() => dispatch(push(`/creators-list/${creatorId}/dashboard/songs/table/`))}>
                        Back
                    </Button>
                </Grid>
                <Grid item xs={8}>
                    <Typography className={classNames('publish-title', css.typography)} variant="h5">
                        Quick Song Entry
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Button className={css.btnBlue} onClick={() => setOpenDrawer(true)}>
                        Set Defaults
                    </Button>
                </Grid>
                <Grid className={classNames(css.gridRight, 'inputcustom-outer')} item xs={2}>
                    <Typography className={classNames('publish-title', css.mode)} variant="h6">
                        Select mode:
                    </Typography>
                    <span>Add</span>
                    <Switch name="isSongReleased" checked={toggle} type="checkbox" onChange={() => setToggle(!toggle)} />
                    <span>Table Edit</span>
                </Grid>
            </Grid>
            {toggle ? (
                <UpdateQuickSongEntry creatorId={creatorId} rows={rows} />
            ) : (
                <CreateQuickSongEntry
                    creatorId={creatorId}
                    rows={rows}
                    addRows={(e) => setRows(state => [...state, e])} />
            )}
            <Drawer variant="persistent" anchor={'right'} open={openDrawer} onClose={() => setOpenDrawer(false)} className={css.drawerStyle}>
                <Typography
                    className={css.closedrawer}
                    onClick={() => {
                        setOpenDrawer(false);
                    }}
                >
                    <Box component="span" fontSize={40} style={{ cursor: 'pointer' }}>
                        <ArrowBackIcon style={{ verticalAlign: 'center', lineHeight: '10px', cursor: 'pointer' }} onClick={() => setOpenDrawer(false)} />
                    </Box>
                    <Box component="span" fontSize={15} className={css.closetitle}>
                        Close
                    </Box>
                </Typography>
                <Divider />
                <DefaultsTab setOpen={setOpenDrawer} />
            </Drawer>
        </article>
    );
};
